<template>
    <div class="lineDownload">
        <div class="lineDownload_body">
            <div class="lineDownload_body_title">
                <div>{{$t('9100095')}}</div>
            </div>
            <div class="open" @click="handleClick">
                <span>{{$t('9100096')}}</span>
                <img src="../assets/images/goFreeRight.png" alt="" />
            </div>
            <div class="imgBox">
                <img src="../assets/images/freeImg.png">
            </div>
            <div :class="['join-us']" class="flex justify-between items-center">
                <div :class="['state-pos-left']">
                    <img :class="['join-us-thumb']" src="@/assets/images/newImg/join-usV3.png" alt="" />
                </div>
                <div :class="['state-pos-right']">
                    <button :class="['btn--download-app']">
                        <span @click="$router.push({path:'/download',query:{type:'purchase'}})" :class="['text']">{{$t('300345')}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex'
    export default {
        created() {
            console.log(this.$route.query, 'this.$route.query==this.$route.query');
            this.resher()
        },
        computed:{
            ...mapGetters(['isDirection', 'language']),
        },
        methods: {
            isSafari() {
                const ua = navigator.userAgent.toLowerCase();
                return (ua.includes('safari') && !ua.includes('chrome') && !ua.includes('android'));
            },
            handleClick() {
                let _this = this
                if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
                    // var loadDateTime = new Date();
                    const { currencyId, memoId } = this.$route.query || {}
                    window.location.href = "superwallet://com.superex.ex?currencyId=" + currencyId + "&memoId=" + memoId;//schema链接或者universal link
                    let timer = setTimeout(function () { //如果没有安装app,便会执行setTimeout跳转下载页
                        // var timeOutDateTime = new Date();
                        // if (timeOutDateTime - loadDateTime < 1000) {
                        _this.$router.push({ path: '/download', query: { type: '' } });
                        clearTimeout(timer)
                        // } else {
                        //   window.close();
                        // }
                    }, 2000);
                } else if (navigator.userAgent.match(/android/i)) {
                    // window.location.href = 'superex://com.aliex.ex'
                    const { currencyId, memoId } = this.$route.query || {}
                    window.location.href = "superwallet://com.superex.ex?currencyId=" + currencyId + "&memoId=" + memoId;//schema链接或者universal link
                    window.setTimeout(() => {
                        try {
                            _this.$router.push({ path: '/download', query: { type: '' } })
                        } catch (e) {
                        }
                    }, 2000)

                }
            },
            resher() {
                this.isApp = this.$route.query.isApp
                let token = this.$route.query.token || this.token
                if (token) {
                    setToken(token);
                    this.$store.dispatch('GetInfo', token);
                    this.$store.dispatch('setToken', token);
                }
                this.$i18n.locale = this.$route.query.language ? this.$route.query.language : 'en'
                setCookie(
                    'language',
                    this.$route.query.language ? this.$route.query.language : 'en'
                )
                this.language = this.$route.query.language
                    ? this.$route.query.language
                    : 'en'
                this.$store.dispatch(
                    'setIsDirection',
                    this.$route.query.language == 'fa' ? true : false
                )
                if (this.$route.query.backgroundColor != "") {
                    window.document.documentElement.setAttribute(
                        "data-theme",
                        this.$route.query.backgroundColor === "day" ? "sunlight" : "moon"
                    );
                } else {
                    window.document.documentElement.setAttribute("data-theme", "moon");
                }
                window.document.documentElement.setAttribute(
                    'dir',
                    this.isDirection ? 'rtl' : 'ltr'
                )
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import "../style/mixin";
    @import "../assets/css/variableName";

    .lineDownload {
        width: 100%;
        min-height: 100vh;
        background: #17171a;
        &_body {
            background: #17171a;
            padding-top: env(safe-area-inset-top);
            width: calc(100% - torem(32));
            margin: 0 auto;
            &_title {
                padding-top: torem(66);
                color: #fff;
                text-align: center;
                font-family: "Plus Jakarta Sans";
                font-size: torem(32);
                font-style: normal;
                font-weight: 800;
                line-height: 120%; /* 76.8px */
                // letter-spacing: -2.56px;
                display: flex;
                justify-content: center;
                // flex-direction: column;
                div{
                    width: 80%;
                }
            }
            .open {
                text-align: center;
                height: torem(54);
                border-radius: torem(50);
                background: linear-gradient(180deg, #f8d753 0%, #fdba06 100%);
                width: torem(174);
                display: flex;
                align-items: center;
                justify-content: center;
                margin: torem(60) auto;
                span {
                    color: var(--Light-, #000922);
                    text-align: center;
                    leading-trim: both;
                    text-edge: cap;
                    font-family: "Plus Jakarta Sans";
                    font-size: torem(16);
                    font-style: normal;
                    font-weight: 600;
                }
                img {
                    margin-left: torem(6);
                    width: torem(15);
                    height: torem(15);
                }
            }
        }
    }
    .imgBox {
        width: 100%;
        display: flex;
        justify-content: center;
        img {
            width: torem(380);
        }
    }
    .join-us {
        position: fixed;
        z-index: calc(var(--g--layer--z-index--lv1) - 10);
        right: 0;
        bottom: calc(env(safe-area-inset-bottom) + 20px);
        left: 0;
        width: 690px;
        margin: 0 auto;
        padding: 30px;

        // border: 1px solid rgb(223 233 251 / 0.2);
        border: 1px solid rgba(223, 233, 251, 0.2);

        border-radius: 12px;
        // background: rgb(45 45 45 / 0.3);
        background: rgba(45, 45, 45, 0.3);

        backdrop-filter: blur(10px);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .join-us-thumb {
            height: 64px;
        }
        .btn--download-app {
            font-size: 24px;
            font-weight: 500;

            padding: 16px 32px;

            text-align: center;

            color: #020920;
            border-radius: 100px;
            // background-color: color(var(--g--color-theme--main));
            background-color: #ffc72b;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/lineDownload.vue